<template>
  <div :class="{ displayed: mobile && displayed }" class="activity_app_fragment_drawer">
    <img v-if="mobile && !displayed" src="/images/iconset/hamburger.svg" class="activity_app_fragment_drawer_hamburger" @click="displayed = true" />
    <img v-if="mobile && displayed" src="/images/iconset/close.svg" class="activity_app_fragment_drawer_hamburger" @click="displayed = false" />
    <uikit-button class="activity_app_fragment_drawer_add_button" icon="plus" title="New chat" @click.native="createChat()" />
    <uikit-list class="activity_app_fragment_drawer_chat_list" :items="chats" v-if="chats.length" @click.native="displayed = false" />
    <!-- <div class="activity_app_fragment_drawer_backdrop" v-if="displayed && mobile" /> -->
  </div>
</template>

<script>
import EventBus from "@/plugins/eventbus";
import UikitList from "@/views/components/uikit/component.uikit.list.vue";
import UikitButton from "@/views/components/uikit/component.uikit.button.vue";

export default {
  name: "ActivityAppFragmentDrawer",
  components: {
    UikitList,
    UikitButton,
  },
  data() {
    return {
      selectedChat: null,
      chats: [],
      displayed: false,
      mobile: true,
    };
  },
  methods: {
    async createChat() {
      this.displayed = false;
      this.$chatApp.createChat();
      this.displayChat(this.$chatApp.chats.length - 1);
      this.chats = this.$chatApp.chats.map((c, i) => {
        return Object.assign(c, {
          callback: () => {
            this.displayChat(i);
          },
        });
      });
    },
    displayChat(selectedChatIndex) {
      this.chats = this.$chatApp.chats.map((c, i) => {
        return Object.assign(c, {
          selected: false,
          callback: () => {
            this.displayChat(i);
          },
        });
      });
      this.selectedChat = this.$chatApp.chats[selectedChatIndex];
      this.selectedChat.selected = true;
      EventBus.$emit("selected_chat", selectedChatIndex);
    },
    handleState() {
      if (this.mobile && !this.displayed) {
        this.displayed = true;
      } else {
        this.displayed = false;
      }
    },
  },
  mounted() {
    EventBus.$on("update_chat", () => {
      this.displayChat(0);
    });
  },
};
</script>

<style scoped>
@media only screen and (orientation: portrait) {
  .activity_app_fragment_drawer_hamburger {
    display: block !important;
    padding: 8px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 5px;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
    overflow: hidden;
  }
  .activity_app_fragment_drawer {
    position: absolute !important;
    left: -100%;
    height: 100%;
    z-index: 200;
    transition: all 0.25s;
  }
  .activity_app_fragment_drawer.displayed {
    left: 0;
    box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);
  }
  .activity_app_fragment_drawer_hamburger {
    position: fixed;
    right: 16px;
    top: 16px;
    cursor: pointer;
  }
  .activity_app_fragment_drawer_backdrop {
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;
    width: 100vw;
    background: rgba(0, 0, 0, 0.2);
  }
}
.activity_app_fragment_drawer {
  display: flex;
  flex-direction: column;
  background: #202123; /* TODO: declare CSS variables in global.css */
  width: 260px;
  padding: 0.5rem;
  box-sizing: border-box;
  gap: 8px;
}
.activity_app_fragment_drawer_hamburger {
  display: none;
}
.activity_app_fragment_drawer_chat_list{
  overflow: hidden;
  overflow-y: auto;
}
</style>
